import React, { useEffect, useState } from "react";
import axios from "axios";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ActionMenu from "./ActionMenu"; // ✅ Make sure this path is correct
import { Link } from "react-router-dom";
import constantApi from "constantApi";

export default function TablePage() {
  const [data, setData] = useState([]);
  const [empFamList, setEmpFamList] = useState([]);

  useEffect(() => {
    axios
      // .get("http://localhost:5610/api/emp_dep_fam/list")
      .get(`${constantApi.baseUrl}/emp_dep_fam/list`)
      .then((res) => {
        console.log("✅ API Response:", res.data);
        setEmpFamList(res.data);
      })
      .catch((err) => {
        console.error("❌ API Error:", err);
      });
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="p-6 bg-gray-50 min-h-screen">
        <div className="bg-white rounded-lg shadow-md p-4">
          {/* Top Header */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-2">
              <span className="text-xl font-semibold">👤 Employee Family</span>
            </div>
            <div className="flex items-center space-x-4">
              <input
                type="text"
                placeholder="Search"
                className="border rounded px-3 py-1 text-sm"
              />
              <Link to="/employeefamily">
                <button className="bg-blue-100 text-blue-700 px-4 py-2 rounded text-sm font-semibold hover:bg-blue-200 transition">
                  + NEW
                </button>
              </Link>

              <button className="text-2xl">☰</button>
            </div>
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm text-left">
              <thead className="bg-gray-100 text-gray-600 uppercase text-xs">
                <tr>
                  <th className="p-3">
                    <input type="checkbox" />
                  </th>

                  <th className="p-4">familyCode</th>
                  <th className="p-4">Name</th>
                  <th className="p-4">Description</th>
                  <th className="p-4">Department</th>
                  <th className="p-4">Note1</th>
                  <th className="p-4">Note2</th>
                  <th className="p-4">Note3</th>
                  <th className="p-4">Date1</th>
                  <th className="p-4">Date2</th>
                  <th className="p-4">AddedBy</th>
                  <th className="p-4">Created Date</th>
                  <th className="p-4">Date</th>
                  <th className="p-4">Company</th>
                  <th className="p-4">Status</th>
                  <th className="p-4">Location</th>
                  <th className="p-4">Action</th>
                </tr>
              </thead>
              <tbody>
                {empFamList.map((empfam, idx) => (
                  <tr key={idx} className="border-t hover:bg-blue-50">
                    <td className="p-3">
                      <input type="checkbox" />
                    </td>
                    <td className="p-4 whitespace-nowrap">
                      {empfam.emp_dpt_famcode}
                    </td>
                    <td className="p-4">{empfam.emp_dpt_famname}</td>
                    <td className="p-4">{empfam.emp_dpt_famlong}</td>
                    <td className="p-4">{empfam.emp_dpt_fdeptname}</td>
                    <td className="p-4">{empfam.note1}</td>
                    <td className="p-4">{empfam.note2}</td>
                    <td className="p-4">{empfam.note3}</td>
                    <td className="p-4">{empfam.amdt1}</td>
                    <td className="p-4">{empfam.amdt2}</td>
                    <td className="p-4">{empfam.addedby}</td>
                    <td className="p-4">{empfam.created_at}</td>
                    <td className="p-4">{empfam.updated_at}</td>
                    <td className="p-4">{empfam.company_id}</td>
                    <td className="p-4">
                      <span className="px-2 py-1 bg-green-100 text-green-700 rounded-full text-xs">
                        {empfam.status}
                      </span>
                    </td>
                    <td className="p-4">{empfam.location_id}</td>
                    <td className="p-3">
                      <ActionMenu
                        onView={() =>
                          alert(`Viewing ${empfam.emp_dpt_famname}`)
                        }
                        onEdit={() =>
                          alert(`Editing ${empfam.emp_dpt_famname}`)
                        }
                        onDelete={() => {
                          const confirmDelete = window.confirm(
                            `Are you sure you want to delete ${empfam.emp_dpt_famname}?`
                          );
                          if (confirmDelete) {
                            alert("Deleted!");
                          }
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
